import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import BadgeCDS, { BadgeColorVariant } from '@sharedCR/coreDesignSystem/BadgeCDS';
import StatusIconCDS from '@sharedCR/coreDesignSystem/StatusIconCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { AiChatTestIds } from '../../../../AiChat.testIds';

import { MessageStatusType, statusIconTypeMap } from './MessageStatus.constants';
import { containerStyles } from './MessageStatus.styles';

const MessageStatus = ({ status, errorsAmount, statusMessage }) => {
  const hasErrorBadge = !_.isNil(errorsAmount) && status === MessageStatusType.ERROR;

  if (!status) {
    return;
  }

  return (
    <Box data-testid={AiChatTestIds.BOT_MESSAGE_STATUS} sx={containerStyles}>
      {hasErrorBadge ? (
        <BadgeCDS colorVariant={BadgeColorVariant.RED} value={errorsAmount} />
      ) : (
        <StatusIconCDS size={IconSize[20]} type={statusIconTypeMap[status]} />
      )}
      {statusMessage && <Typography variant="medium14">{statusMessage}</Typography>}
    </Box>
  );
};

MessageStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(MessageStatusType)),
  errorsAmount: PropTypes.number,
  statusMessage: PropTypes.string,
};

export default memo(MessageStatus);
